var map = {
	"./DSCF7930.jpg": 9623,
	"./DSCF7943.jpg": 3116,
	"./DSCF7946.jpg": 9347,
	"./DSCF7950.jpg": 3597,
	"./DSCF7964.jpg": 3631,
	"./DSCF7969.jpg": 1944,
	"./DSCF7986.jpg": 4348
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6907;